module.exports = __webpack_public_path__ + "img/product_127.e82677e.webp";